import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css"
import 'bootstrap-rtl/dist/css/bootstrap-rtl.css'
// import './css/normalize.css'; // استيراد normalize.css
// import './css/all.min.css'; // استيراد FontAwesome
// import './css/main-style.css'; // استيراد main-style.css
// import './css/home.css'; // استيراد home.css
// import './css/NormalReda.css'; // استيراد NormalReda.css
// import './script/scroll-to-top/scroll-button.css'; // استيراد scroll-button.css









ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
  
